// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {Form, PopoverType} from '@supermove/hooks';
import {EmailTemplateModel} from '@supermove/models';

// App
import ActionMenuPopover from '@shared/design/components/ActionMenu/ActionMenuPopover';
import {WrappedEmailFormType} from '@shared/modules/Email/hooks/useSendEmailForProjectMutation';

const CommunicationInboxFooterEmailTemplatesPopover = ({
  popover,
  selectedEmailTemplateId,
  emailTemplates,
  form,
  field,
  handleSelectEmailTemplateUuid,
  children,
}: {
  popover: PopoverType;
  selectedEmailTemplateId?: string;
  emailTemplates: EmailTemplateModel[];
  form: Form<WrappedEmailFormType>;
  field: string;
  handleSelectEmailTemplateUuid: (emailTemplateUuid: string) => void;
  children: React.ReactNode;
}) => {
  const displayTemplates = emailTemplates.filter(
    (template) => !template.isDeleted || template.id === selectedEmailTemplateId,
  );

  const emailTemplateActions = displayTemplates.map((template) => ({
    text: template.name,
    onPress: () => handleSelectEmailTemplateUuid(template.uuid),
  }));

  return (
    <ActionMenuPopover
      popover={popover}
      placement={ActionMenuPopover.Position.TopEnd}
      actions={emailTemplateActions}
      popoverMaxHeight={600}
      width={300}
      isSearchable
    >
      {children}
    </ActionMenuPopover>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
CommunicationInboxFooterEmailTemplatesPopover.fragment = gql`
  fragment CommunicationInboxFooterEmailTemplatesPopover on EmailTemplate {
    id
    uuid
    kind
    name
    isDeleted
    # There should be some kind of fragment for these, this is used to set the preview
    subject
    bodyKind
    body
  }
`;

export default CommunicationInboxFooterEmailTemplatesPopover;
